import { Component, inject, OnInit } from '@angular/core';

import CONSTANTS from '@constants';
import { environment } from '@environments/environment';
import { CompanyService } from '@app/shared/services/company.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-legal-terms-footer',
  templateUrl: './legal-terms-footer.component.html',
  host: { class: 'legal-terms-footer' },
  imports: [TranslocoModule]
})
export class LegalTermsFooterComponent implements OnInit {
  private readonly companyManager = inject(CompanyService);
  imprint: string;
  privacyPolicy: string;
  terms: string;

  ngOnInit(): void {
    const domain = this.companyManager.domain(environment.API_BASE);
    const subdomain = this.companyManager.subdomain;

    if (subdomain) {
      const legalTermsUrl = `https://${subdomain}.${domain}/legal-terms`;
      this.terms = `${legalTermsUrl}/terms-of-use`;
      this.privacyPolicy = `${legalTermsUrl}/privacy-policy`;
      this.imprint = `${legalTermsUrl}/imprint`;
    } else {
      this.terms = CONSTANTS.WEB_LINKS.TERMS_SERVICE;
      this.privacyPolicy = CONSTANTS.WEB_LINKS.PRIVACY_POLICY;
      this.imprint = CONSTANTS.WEB_LINKS.IMPRINT;
    }
  }
}
